import React, { useEffect, useContext } from "react";
import { json, Navigate } from "react-router-dom";
import UserContext from "../../context/User";
import { useDispatch } from "react-redux";
import { setServiceDomainTab } from "../../redux/certification/action";

const ProtectedRoute = ({ children }) => {
  // const UserConsumer = useContext(UserContext);
  // const { loggedinUser } = UserConsumer;

  const loggedinUser = JSON.parse(localStorage.getItem("userDetails"));

  const dispatch = useDispatch();

  useEffect(() => {
    console.log("loggedinUser🌍🌍🌍📌", loggedinUser);
    dispatch(setServiceDomainTab("100"));
  }, []);

  // useEffect(() => {
  //   if (loggedinUser) {
  //     localStorage.setItem("userDetails", JSON.stringify(loggedinUser));
  //   }
  // }, [loggedinUser]);

  if (loggedinUser?.isLoggedIn) {
    if (loggedinUser?.fullDetails?.status?.toLowerCase() === "active") {
      return children;
    }
    return <Navigate to="/login" />;
  }
  return <Navigate to="/login" />;
};

export default ProtectedRoute;
